import { CommandType } from "~app/common/services/cqs/CommandType";
import { AnmalanTradslagBaseCommand } from "./AnmalanTradslagBaseCommand";

export class UpdateAnmalanTradslagCommand extends AnmalanTradslagBaseCommand {
    readonly tradslagId: number;
    readonly antalPlantor: number;
    readonly arealHa: number;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "UpdateAnmalanTradslagCommand";

    constructor(atgardGuid: string, anmalanTradlagGuid: string, tradslagId: number, arealHa: number, antalPlantor: number) {
        super(atgardGuid, anmalanTradlagGuid, UpdateAnmalanTradslagCommand.$type, CommandType.Replace);
        this.tradslagId = tradslagId;
        this.arealHa = arealHa;
        this.antalPlantor = antalPlantor;
    }
}
